"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _intlDesignUi = require("@tencent/intl-design-ui");
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var _formatVodData4 = require("../../utils/formatVodData");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatList = list => {
  const configuration = list.map((item, index) => {
    const _item$backgroundUrl = item.backgroundUrl,
      backgroundUrl = _item$backgroundUrl === void 0 ? '' : _item$backgroundUrl,
      _item$footerLink = item.footerLink,
      footerLink = _item$footerLink === void 0 ? {} : _item$footerLink,
      _item$links = item.links,
      links = _item$links === void 0 ? [] : _item$links;
    const _footerLink$text = footerLink.text,
      text = _footerLink$text === void 0 ? '' : _footerLink$text,
      _footerLink$to = footerLink.to,
      to = _footerLink$to === void 0 ? '' : _footerLink$to;
    const _formatVodData = (0, _formatVodData4.formatVodData)(backgroundUrl),
      formatBackgroundUrl = _formatVodData.url;
    const resultLinks = links.map((item, index) => {
      const _ref = item || {},
        _ref$text = _ref.text,
        text = _ref$text === void 0 ? '' : _ref$text,
        _ref$icon = _ref.icon,
        icon = _ref$icon === void 0 ? '' : _ref$icon,
        _ref$hoverIcon = _ref.hoverIcon,
        hoverIcon = _ref$hoverIcon === void 0 ? '' : _ref$hoverIcon,
        _ref$to = _ref.to,
        to = _ref$to === void 0 ? '' : _ref$to;
      const _formatVodData2 = (0, _formatVodData4.formatVodData)(icon),
        formatIcon = _formatVodData2.url;
      const _formatVodData3 = (0, _formatVodData4.formatVodData)(hoverIcon),
        formatHoverIcon = _formatVodData3.url;
      return {
        text,
        to,
        icon: formatIcon,
        hoverIcon: formatHoverIcon,
        key: `${index + 1}`,
        extendProps: {
          'report-event-goal': 'click_accordion',
          'report-event': 'click_accordion_links_href',
          'report-ext1': index,
          'report-ext2': text,
          'report-ext3': to
        }
      };
    });
    return _objectSpread(_objectSpread({}, item), {}, {
      footerLink: {
        text,
        to
      },
      backgroundUrl: formatBackgroundUrl,
      links: resultLinks,
      key: `${index + 1}`,
      extendProps: {
        'report-event-goal': 'click_accordion',
        'report-event': 'click_accordion_footer_href',
        'report-ext1': index,
        'report-ext2': text,
        'report-ext3': to
      }
    });
  });
  return configuration;
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const componentData = data;
  if (componentData) {
    const porintId = data.porintId,
      paddingTopNum = data.paddingTopNum,
      paddingBottomNum = data.paddingBottomNum,
      _data$title = data.title,
      title = _data$title === void 0 ? '' : _data$title,
      _data$desc = data.desc,
      desc = _data$desc === void 0 ? '' : _data$desc,
      _data$color = data.color,
      color = _data$color === void 0 ? '' : _data$color,
      _data$list = data.list,
      list = _data$list === void 0 ? [] : _data$list;
    const resultList = formatList(list);
    const bgStyle = {};
    if (color) {
      bgStyle.background = color;
    }
    const paddingStyle = (0, _componentUtils.doComponentsStyleEvent)({
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件背景色
    paddingStyle.minWidth = 'unset';
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId
    }, (0, _reportUtil.reportShow)(['show_accordion', componentKey, porintId]), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      col: 1,
      title: title,
      desc: desc,
      style: paddingStyle
    }, /*#__PURE__*/React.createElement(_intlDesignUi.Accordion, {
      list: resultList
    })));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}